<template>
  <div>
    <div v-for="(item, index) in contextOther" :key="item.id">
      <div v-if="item.type === 'summary'">
        <v-row justify="center" no-gutters class="flex-nowrap">
          <v-col cols="12">
            <v-row dense>
              <v-col cols="12" :md="!isReInvoicingForExternalContractorModuleEnabled ? 6 : 4">
                <v-text-field
                  v-model="item.bill_description"
                  :label="$t('delegation.form.fields.other.billDescription.name')"
                  :error-messages="contextErrors[index].bill_description"
                  :readonly="$store.state.Delegation.readonly === true"
                />
              </v-col>
              <v-col cols="12" md="2" v-if="isReInvoicingForExternalContractorModuleEnabled">
                <v-checkbox label="Internal" v-model="item.is_internal_cost" :readonly="$store.state.Delegation.readonly === true" />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="item.bill_number"
                  :label="$t('delegation.form.fields.other.billNumber.name')"
                  :error-messages="contextErrors[index].bill_number"
                  :readonly="$store.state.Delegation.readonly === true"
                />
              </v-col>
              <v-col cols="12" md="3">
                <date-picker
                  :label="$t('delegation.form.fields.other.billDate.name')"
                  :model.sync="item.bill_date"
                  :dateValidation="contextErrors[index].bill_date"
                  :readonly="$store.state.Delegation.readonly === true"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  v-model="item.type_id"
                  :label="$t('delegation.form.fields.other.type.name')"
                  :items="transport_types"
                  item-text="name"
                  :error-messages="contextErrors[index].type_id"
                  item-value="id"
                  :readonly="$store.state.Delegation.readonly === true"
                />
              </v-col>
              <v-col cols="12" md="2">
                <v-autocomplete
                  v-model="item.payment_type_id"
                  :items="payment_types"
                  item-text="name"
                  item-value="id"
                  :label="$t('delegation.form.fields.other.paymentType.name')"
                  :clearable="$store.state.Delegation.readonly !== true"
                  :error-messages="contextErrors[index].payment_type_id"
                  :readonly="$store.state.Delegation.readonly === true"
                />
              </v-col>
              <v-col cols="8" md="2">
                <AmountInput
                  :error-messages="contextErrors[index].amount_in_currency"
                  :model.sync="item.amount_in_currency"
                  :readonly="$store.state.Delegation.readonly === true"
                />
              </v-col>
              <v-col cols="4" md="1">
                <currency-select
                  :model.sync="item.currency"
                  :validation-message="contextErrors[index].currency"
                  :readonly="$store.state.Delegation.readonly === true"
                />
              </v-col>
              <v-col cols="12" md="3">
                <ajax-single-file
                  :accept="$store.getters['Delegation/allowedAttachmentFileFormat']"
                  :items="fileProperties(item.file_id)"
                  :model.sync="item.file_id"
                  v-on:fileUploaded="addFileToDelegationFiles"
                  v-on:fileRemoved="removeFileFromDelegationFiles"
                  :readonly="$store.state.Delegation.readonly === true"
                />
              </v-col>
              <v-col cols="12" md="6" v-if="showIsReInvoicingCost">
                <v-checkbox
                  label="Stanowi koszt do refakturowania"
                  v-model="item.is_external_client_cost"
                  :readonly="$store.state.Delegation.readonly === true"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-spacer />
          <v-col class="d-flex align-center justify-center" v-if="clearable">
            <v-tooltip top class="hidden-sm-and-down">
              {{ $t("global.removeItem") }}
              <template #activator="{on}">
                <v-btn icon v-on="on" @click="removeOther(item)">
                  <v-icon>close</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-btn class="hidden-md-and-up" v-on:click="removeOther(item)" v-if="clearable">
          {{ $t("global.removeItem") }}
        </v-btn>
        <v-divider class="mb-2" v-if="contextOther.indexOf(item) !== contextOther.length - 1" />
      </div>
    </div>
  </div>
</template>

<script>
import CurrencySelect from "../../../CustomInputComponents/CurrencySelect.vue";
import DatePicker from "../../../CustomInputComponents/DatePicker.vue";
import PaymentTypes from "../../../../staticData/OtherSummaryPaymentTypes";
import OtherSummaryTypes from "../../../../staticData/OtherSummaryTypes";
import AjaxSingleFile from "../../../CustomInputComponents/AjaxSingleFile.vue";
import AmountInput from "../../../CustomInputComponents/AmountInput.vue";

export default {
  name: "SimpleOtherSummaryList",
  props: {
    modelOther: {
      required: true
    },
    clearable: {
      required: false,
      default: false
    }
  },
  components: { AjaxSingleFile, DatePicker, CurrencySelect, AmountInput },
  methods: {
    removeOther(item) {
      this.$emit("removeOtherItem", item);
      this.removeFileFromDelegationFiles(item);
    },
    addFileToDelegationFiles(item) {
      const newItem = item;
      newItem.description = this.$t("delegation.form.fileAttachmentDescription.otherGeneral");
      newItem.category = "otherSummary";
      this.$store.dispatch("Delegation/addFile", newItem);
    },
    removeFileFromDelegationFiles(item) {
      this.$store.dispatch("Delegation/removeFile", item.id);
    },
    fileProperties(fileId) {
      let temp = this.$store.getters["Delegation/delegationEdited"].file.find(function(element) {
        return element.id === fileId;
      });
      if (typeof temp !== "undefined") {
        return [temp];
      }
      return [];
    }
  },
  computed: {
    isReInvoicingForExternalContractorModuleEnabled() {
      return this.$store.getters["userProperties"].system_settings.external_customers_module === 2;
    },
    payment_types: PaymentTypes,
    transport_types: OtherSummaryTypes,
    contextOther: {
      set(value) {
        this.$emit("update:modelOther", value);
      },
      get() {
        return this.modelOther;
      }
    },
    contextErrors() {
      return this.$store.getters["Delegation/delegationErrors"].other;
    },
    showIsReInvoicingCost() {
      return this.$store.getters["userProperties"].system_settings.re_invoicing_for_external_contractor_module === 2;
    }
  }
};
</script>

<style scoped></style>
